<mat-dialog-content>
  <section *ngIf="loading">
    <h2>Loading...</h2>
    <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
    </mat-progress-bar>
  </section>
  <div *ngIf="!loading" fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader">
        <mat-icon>delete</mat-icon> Delete  
      </h2>
    </div>
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
      <form #form="ngForm" (ngSubmit)="onSubmit()">
        <button type="submit" mat-raised-button color="primary" title="Yes - Delete">Yes - Delete</button>
      </form>
      &nbsp;&nbsp;
      <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" mat-raised-button color="basic" title="Close"
        [disabled]='processing || loading'>Close</button>
    </div>
  </div>
  <div *ngIf="!loading" fxLayout="row wrap" class="matero-row">
    <mat-card fxFlex="100" fxFlex.lt-sm="100">
       
      Are you sure you want to delete Treatment <strong>{{treatment.treatmentId}}</strong>?
    </mat-card>
  </div>
</mat-dialog-content>